import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Table } from '../shared/types';
import { PaymentTransactionsService } from '../payment-transactions/payment-transactions.service';
import { HelperService } from '../helper.service';

@Component({
  selector: 'app-payment-transactions',
  templateUrl: './payment-transactions.component.html',
  styleUrls: ['./payment-transactions.component.css']
})
export class PaymentTransactionsComponent implements OnInit {
  txnListData: Table;
  public updatedFraudData: any;

  constructor(
    private paymentTransactionsService: PaymentTransactionsService,
    public dialogRef: MatDialogRef<PaymentTransactionsComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) { }

  onNoClick(): void {
    this.dialogRef.close();
  }

  ngOnInit() {
    this.declareTable() 
  }

  declareTable() {
    this.txnListData = new Table({
      tableHeader: this.data.title,

      headers: {
        id:                     "S.No",
        transactionId:          "Transaction ID",
        amount:                 "Amount",
        status:                 "Status",
        transactionType:        "Transaction Type",
        createdAt:              "Created At",
        updatedAt:              "Updated At",
        paymentMethod:          "Payment Method",
        paymentAccountIdentifier: "Payment Account Identifier",
        paymentAccountName:     "Payment Account Name",
        currency:               "Currency"
      },
      config: {
        refresh: false,
        filter: false
      }
    })

    this.loadTableData()
    
  }

  doRefresh() {
    this.txnListData.data = []
    this.loadTableData()
  }

  loadTableData() {
    const that = this;
    const orderId = this.data.info.orderId;
    const captainId = this.data.info.captainId;
    
    this.paymentTransactionsService.getPaymentTransactions(orderId, captainId).subscribe((response: any) => {
      if(response.statusCode == 200 || response.status === 'success') {
        let txnData = []
        const responseData = response.data || {};
        const transactions = responseData.transactions || [];
        
        for(let i=0; i<transactions.length; i++) {
          const txn = transactions[i];
          const metadata = txn.metadata || {};
          const createdAtRaw = txn.createdAt || txn.created_at || txn.updatedOn;
          const updatedAtRaw = txn.updatedOn || txn.updatedAt || txn.updated_at;
          
          txnData.push({
            id:                     i+1,
            transactionId:          metadata.rpnId || "-",
            amount:                 txn.amount || "-",
            status:                 txn.status || "-",
            transactionType:        txn.transactionType || txn.type || "-",
            createdAt:              HelperService.formatDateWithTime(createdAtRaw),
            updatedAt:              HelperService.formatDateWithTime(updatedAtRaw),
            paymentMethod:          txn.paymentMode || txn.paymentMethod || txn.payment_method || "-",
            paymentAccountIdentifier: metadata.paymentAccountIdentifier || "-",
            paymentAccountName:     metadata.paymentAccountName || "-",
            currency:               txn.currency || "INR"
          })
        }
        if(that.txnListData.data.length == 0) {
          that.txnListData.data = []
        }

        that.txnListData.data = [...that.txnListData.data, ...txnData]
      }
    }, (error) => {
      console.error('Error loading payment transactions:', error);
      that.txnListData.data = [];
    })
  }
}
